import { render, staticRenderFns } from "./logo-header.vue?vue&type=template&id=1b4ce834&scoped=true&"
import script from "./logo-header.vue?vue&type=script&lang=js&"
export * from "./logo-header.vue?vue&type=script&lang=js&"
import style0 from "./logo-header.vue?vue&type=style&index=0&id=1b4ce834&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ce834",
  null
  
)

export default component.exports